export default __webpack_public_path__ + "static/media/Image1.97c307e5.png";